var multiFilter = {};

jQuery(function () {

    function checkNoResults() {

        jQuery('.multi-filter__no-results').addClass('multi-filter__no-results--hide');

        if (jQuery('.multi-filter__option-list--' + multiFilter.chosenCountry + ' > .multi-filter__option--show').length < 1) {
            jQuery('.multi-filter__option-list--' + multiFilter.chosenCountry + ' + .multi-filter__no-results').removeClass('multi-filter__no-results--hide');
        } else {
            jQuery('.multi-filter__option-list--' + multiFilter.chosenCountry + ' + .multi-filter__no-results').addClass('multi-filter__no-results--hide');
        }
    }

    function filterByLetter() {

        jQuery('.multi-filter__option-list--' + multiFilter.chosenCountry + ' > div').each(function () {
            jQuery(this).removeClass('multi-filter__option--hide');

            var airline = jQuery(this).find('.multi-filter__option').text().toUpperCase().trim();
            var firstLetter = airline.charAt(0);

            if (multiFilter.chosenLetterRange && multiFilter.chosenLetterRange.indexOf(firstLetter) >= 0) {
                jQuery(this).addClass('multi-filter__option--show');
            } else {
                jQuery(this).removeClass('multi-filter__option--show');
                jQuery(this).addClass('multi-filter__option--hide');
            }
        });
    }

    // function checkCountryValues(current_value) {
    //     switch (current_value) {
    //         case 'usa':
    //             current_value = 'United States';
    //             multiFilter.chosenCountry = 'usa';
    //             break;
    //         case 'international':
    //             current_value = 'International';
    //             multiFilter.chosenCountry = 'international';
    //             break;
    //         default:
    //             current_value = 'Canada';
    //     }

    //     return current_value;
    // }

    multiFilter.letterRanges = {
        '0-9': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        'A-Z': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
        'A-C': ['A', 'B', 'C'],
        'D-F': ['D', 'E', 'F'],
        'G-I': ['G', 'H', 'I'],
        'J-L': ['J', 'K', 'L'],
        'M-O': ['M', 'N', 'O'],
        'P-S': ['P', 'Q', 'R', 'S'],
        'T-V': ['T', 'U', 'V'],
        'W-Z': ['W', 'X', 'Y', 'Z'],
        'ALL': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    };

    function getChosenRangeKey(range) {
        var match;

        jQuery.each(Object.keys(multiFilter.letterRanges), function (index, item) {
            if (multiFilter.letterRanges[item] === range) {
                match = item;
            }
        });

        return match;
    }

    function setCurrentAlphaButton(range) {
        var current_range = getChosenRangeKey(range) || 'A-C';
        jQuery('.multi-filter__letters-button').removeClass('multi-filter__letters-button--selected');
        jQuery('.multi-filter__letters-button:contains("' + current_range + '")').addClass('multi-filter__letters-button--selected');
    }

    jQuery('*[class^="multi-filter__option-list--"]').not(':eq(0)').hide();

    //Check if the country multi filter exist if yes then default it to canada
    jQuery(".multi-filter__countries-wrap").length > 0 ? multiFilter.chosenCountry = jQuery('.multi-filter__country-button--selected').text().toLowerCase() : multiFilter.chosenCountry = "canada";

    var $select = jQuery('[name="multi_options_select"]');

    // kick things off
    // 1. Set the letter range
    // 2. filter the results buy the selected letter
    multiFilter.chosenLetterRange = jQuery('.multi-filter__letters-button--selected')[0] ?
        multiFilter.letterRanges[jQuery('.multi-filter__letters-button--selected')[0].innerHTML.toUpperCase()] : null;
    filterByLetter();
    checkNoResults();

    //
    jQuery('body').on('click', '.multi-filter__countries button', function (e) {
        var countryClicked = e.target;

        if (jQuery(countryClicked).text().toLowerCase() == 'united states') {
            multiFilter.chosenCountry = 'usa';
        } else {
            multiFilter.chosenCountry = jQuery(e.target).text().toLowerCase();
        }

        $select.val(multiFilter.chosenCountry);

        jQuery('.multi-filter__letters-button').removeClass('multi-filter__letters-button--selected');

        setCurrentAlphaButton(multiFilter.chosenLetterRange);

        jQuery('.multi-filter__countries button').removeClass('multi-filter__country-button--selected');
        jQuery(countryClicked).addClass('multi-filter__country-button--selected');

        jQuery('*[class^="multi-filter__option-list--"]').not('.multi-filter__option-list--' + multiFilter.chosenCountry).fadeOut('fast', function () {
            jQuery('.multi-filter__option-list--' + multiFilter.chosenCountry).fadeIn('slow');
        });

        filterByLetter();
        checkNoResults();

    });


    jQuery('body').on('change', '[name="multi_options_select"]', function (e) {
        var $this = jQuery(this);
        var current_value = $this.val();
        //console.log($this);
        //console.log("current_value" + current_value);
        //console.log("select drop down");

        jQuery('*[class^="multi-filter__option-list--"]').not('.multi-filter__option-list--' + current_value).fadeOut('fast', function () {
            //console.log(jQuery('.multi-filter__option-list--' + current_value.toLowerCase()));
            jQuery('.multi-filter__option-list--' + current_value.toLowerCase()).show();
        });

        switch (current_value) {
            case 'usa':
                current_value = 'United States';
                multiFilter.chosenCountry = 'usa';
                break;
            case 'international':
                current_value = 'International';
                multiFilter.chosenCountry = 'international';
                break;
            case 'in-store':
                current_value = 'In-Store';
                multiFilter.chosenCountry = 'in-store';
                break;
            case 'online':
                current_value = 'Online';
                multiFilter.chosenCountry = 'online';
                break;
            default:
                current_value = 'Canada';
                multiFilter.chosenCountry = 'canada';
        }

        jQuery('.multi-filter__countries button').removeClass('multi-filter__country-button--selected');

        jQuery('.multi-filter__countries button:contains("' + current_value + '")').addClass('multi-filter__country-button--selected');
        jQuery('.multi-filter__letters-button').removeClass('multi-filter__letters-button--selected');

        setCurrentAlphaButton(multiFilter.chosenLetterRange);

        filterByLetter();
        checkNoResults();

    });

    jQuery('body').on('click', '.multi-filter__letters .multi-filter__letters-button', function (e) {

        jQuery('.multi-filter__letters-button').removeClass('multi-filter__letters-button--selected');
        jQuery(e.target).addClass('multi-filter__letters-button--selected');

        multiFilter.chosenLetterRange = multiFilter.letterRanges[jQuery(e.target).text().toUpperCase()];

        //now filter it by letter
        filterByLetter();

        checkNoResults();
    });

});


